export class Encodings {
  static get list() {
    return [{codePage: 20106, name: 'x-IA5-German', displayName: 'Alemão (IA5)'},
      {codePage: 864, name: 'IBM864', displayName: 'Árabe (864)'},
      {codePage: 708, name: 'ASMO-708', displayName: 'Árabe (ASMO 708)'},
      {codePage: 720, name: 'DOS-720', displayName: 'Árabe (DOS)'},
      {codePage: 28596, name: 'iso-8859-6', displayName: 'Árabe (ISO)'},
      {codePage: 10004, name: 'x-mac-arabic', displayName: 'Árabe (Mac)'},
      {codePage: 1256, name: 'windows-1256', displayName: 'Árabe (Windows)'},
      {codePage: 775, name: 'ibm775', displayName: 'Báltico (DOS)'},
      {codePage: 28594, name: 'iso-8859-4', displayName: 'Báltico (ISO)'},
      {codePage: 1257, name: 'windows-1257', displayName: 'Báltico (Windows)'},
      {codePage: 10029, name: 'x-mac-ce', displayName: 'Centro-europeu (Mac)'},
      {codePage: 1250, name: 'windows-1250', displayName: 'Centro-europeu (Windows)'},
      {codePage: 51936, name: 'EUC-CN', displayName: 'Chinês Simplificado (EUC)'},
      {codePage: 54936, name: 'GB18030', displayName: 'Chinês Simplificado (GB18030)'},
      {codePage: 936, name: 'gb2312', displayName: 'Chinês Simplificado (GB2312)'},
      {codePage: 20936, name: 'x-cp20936', displayName: 'Chinês Simplificado (GB2312-80)'},
      {codePage: 52936, name: 'hz-gb-2312', displayName: 'Chinês Simplificado (HZ)'},
      {codePage: 50227, name: 'x-cp50227', displayName: 'Chinês Simplificado (ISO-2022)'},
      {codePage: 10008, name: 'x-mac-chinesesimp', displayName: 'Chinês Simplificado (Mac)'},
      {codePage: 950, name: 'big5', displayName: 'Chinês Tradicional (Big5)'},
      {codePage: 20000, name: 'x-Chinese-CNS', displayName: 'Chinês Tradicional (CNS)'},
      {codePage: 20002, name: 'x-Chinese-Eten', displayName: 'Chinês Tradicional (Eten)'},
      {codePage: 10002, name: 'x-mac-chinesetrad', displayName: 'Chinês Tradicional (Mac)'},
      {codePage: 866, name: 'cp866', displayName: 'Cirílico (DOS)'},
      {codePage: 28595, name: 'iso-8859-5', displayName: 'Cirílico (ISO)'},
      {codePage: 20866, name: 'koi8-r', displayName: 'Cirílico (KOI8-R)'},
      {codePage: 21866, name: 'koi8-u', displayName: 'Cirílico (KOI8-U)'},
      {codePage: 10007, name: 'x-mac-cyrillic', displayName: 'Cirílico (Mac)'},
      {codePage: 1251, name: 'windows-1251', displayName: 'Cirílico (Windows)'},
      {codePage: 949, name: 'ks_c_5601-1987', displayName: 'Coreano'},
      {codePage: 51949, name: 'euc-kr', displayName: 'Coreano (EUC)'},
      {codePage: 50225, name: 'iso-2022-kr', displayName: 'Coreano (ISO)'},
      {codePage: 1361, name: 'Johab', displayName: 'Coreano (Johab)'},
      {codePage: 10003, name: 'x-mac-korean', displayName: 'Coreano (Mac)'},
      {codePage: 20949, name: 'x-cp20949', displayName: 'Coreano Wansung'},
      {codePage: 10082, name: 'x-mac-croatian', displayName: 'Croata (Mac)'},
      {codePage: 28603, name: 'iso-8859-13', displayName: 'Estoniano (ISO)'},
      {codePage: 29001, name: 'x-Europa', displayName: 'Europa'},
      {codePage: 852, name: 'ibm852', displayName: 'Europa Central (DOS)'},
      {codePage: 28592, name: 'iso-8859-2', displayName: 'Europa Central (ISO)'},
      {codePage: 850, name: 'ibm850', displayName: 'Europa Ocidental (DOS)'},
      {codePage: 20105, name: 'x-IA5', displayName: 'Europa Ocidental (IA5)'},
      {codePage: 28591, name: 'iso-8859-1', displayName: 'Europa Ocidental (ISO)'},
      {codePage: 10000, name: 'macintosh', displayName: 'Europa Ocidental (Mac)'},
      {codePage: 1252, name: 'Windows-1252', displayName: 'Europa Ocidental (Windows)'},
      {codePage: 863, name: 'IBM863', displayName: 'Francês Canadense (DOS)'},
      {codePage: 737, name: 'ibm737', displayName: 'Grego (DOS)'},
      {codePage: 28597, name: 'iso-8859-7', displayName: 'Grego (ISO)'},
      {codePage: 10006, name: 'x-mac-greek', displayName: 'Grego (Mac)'},
      {codePage: 1253, name: 'windows-1253', displayName: 'Grego (Windows)'},
      {codePage: 869, name: 'ibm869', displayName: 'Grego Moderno (DOS)'},
      {codePage: 862, name: 'DOS-862', displayName: 'Hebraico (DOS)'},
      {codePage: 38598, name: 'iso-8859-8-i', displayName: 'Hebraico (ISO-Lógico)'},
      {codePage: 28598, name: 'iso-8859-8', displayName: 'Hebraico (ISO-Visual)'},
      {codePage: 10005, name: 'x-mac-hebrew', displayName: 'Hebraico (Mac)'},
      {codePage: 1255, name: 'windows-1255', displayName: 'Hebraico (Windows)'},
      {codePage: 20273, name: 'IBM273', displayName: 'IBM EBCDIC (Alemanha)'},
      {codePage: 1141, name: 'IBM01141', displayName: 'IBM EBCDIC (Alemanha-Euro)'},
      {codePage: 20420, name: 'IBM420', displayName: 'IBM EBCDIC (Árabe)'},
      {codePage: 20833, name: 'x-EBCDIC-KoreanExtended', displayName: 'IBM EBCDIC (Coreano Estendido)'},
      {codePage: 20277, name: 'IBM277', displayName: 'IBM EBCDIC (Dinamarca-Noruega)'},
      {codePage: 1142, name: 'IBM01142', displayName: 'IBM EBCDIC (Dinamarca-Noruega-Euro)'},
      {codePage: 20284, name: 'IBM284', displayName: 'IBM EBCDIC (Espanha)'},
      {codePage: 1145, name: 'IBM01145', displayName: 'IBM EBCDIC (Espanha-Euro)'},
      {codePage: 37, name: 'IBM037', displayName: 'IBM EBCDIC (EUA-Canadá)'},
      {codePage: 1140, name: 'IBM01140', displayName: 'IBM EBCDIC (EUA-Canadá-Euro)'},
      {codePage: 20278, name: 'IBM278', displayName: 'IBM EBCDIC (Finlândia-Suécia)'},
      {codePage: 1143, name: 'IBM01143', displayName: 'IBM EBCDIC (Finlândia-Suécia-Euro)'},
      {codePage: 20297, name: 'IBM297', displayName: 'IBM EBCDIC (França)'},
      {codePage: 1147, name: 'IBM01147', displayName: 'IBM EBCDIC (França-Euro)'},
      {codePage: 875, name: 'cp875', displayName: 'IBM EBCDIC (Grego Moderno)'},
      {codePage: 20423, name: 'IBM423', displayName: 'IBM EBCDIC (Grego)'},
      {codePage: 20424, name: 'IBM424', displayName: 'IBM EBCDIC (Hebraico)'},
      {codePage: 500, name: 'IBM500', displayName: 'IBM EBCDIC (Internacional)'},
      {codePage: 1148, name: 'IBM01148', displayName: 'IBM EBCDIC (Internacional-Euro)'},
      {codePage: 20871, name: 'IBM871', displayName: 'IBM EBCDIC (Islandês)'},
      {codePage: 1149, name: 'IBM01149', displayName: 'IBM EBCDIC (Islandês-Euro)'},
      {codePage: 20280, name: 'IBM280', displayName: 'IBM EBCDIC (Itália)'},
      {codePage: 1144, name: 'IBM01144', displayName: 'IBM EBCDIC (Itália-Euro)'},
      {codePage: 20290, name: 'IBM290', displayName: 'IBM EBCDIC (Japonês katakana)'},
      {codePage: 870, name: 'IBM870', displayName: 'IBM EBCDIC (Latino Multilíngüe-2)'},
      {codePage: 20880, name: 'IBM880', displayName: 'IBM EBCDIC (Russo Cirílico)'},
      {codePage: 21025, name: 'cp1025', displayName: 'IBM EBCDIC (Servo-Búlgaro Cirílico)'},
      {codePage: 20838, name: 'IBM-Thai', displayName: 'IBM EBCDIC (Tai)'},
      {codePage: 1026, name: 'IBM1026', displayName: 'IBM EBCDIC (Turco Latino-5)'},
      {codePage: 20905, name: 'IBM905', displayName: 'IBM EBCDIC (Turco)'},
      {codePage: 20285, name: 'IBM285', displayName: 'IBM EBCDIC (UK)'},
      {codePage: 1146, name: 'IBM01146', displayName: 'IBM EBCDIC (UK-Euro)'},
      {codePage: 1047, name: 'IBM01047', displayName: 'IBM Latino-1'},
      {codePage: 20924, name: 'IBM00924', displayName: 'IBM Latino-1'},
      {codePage: 20003, name: 'x-cp20003', displayName: 'IBM5550 Taiwan'},
      {codePage: 57006, name: 'x-iscii-as', displayName: 'ISCII Assamês'},
      {codePage: 57003, name: 'x-iscii-be', displayName: 'ISCII Bengali'},
      {codePage: 57008, name: 'x-iscii-ka', displayName: 'ISCII Canarim'},
      {codePage: 57002, name: 'x-iscii-de', displayName: 'ISCII Devanágari'},
      {codePage: 57010, name: 'x-iscii-gu', displayName: 'ISCII Guzerate'},
      {codePage: 57009, name: 'x-iscii-ma', displayName: 'ISCII Malaio'},
      {codePage: 57007, name: 'x-iscii-or', displayName: 'ISCII Odia'},
      {codePage: 57011, name: 'x-iscii-pa', displayName: 'ISCII Panjabi'},
      {codePage: 57004, name: 'x-iscii-ta', displayName: 'ISCII Tâmil'},
      {codePage: 57005, name: 'x-iscii-te', displayName: 'ISCII Telugu'},
      {codePage: 861, name: 'ibm861', displayName: 'Islandês (DOS)'},
      {codePage: 10079, name: 'x-mac-icelandic', displayName: 'Islandês (Mac)'},
      {codePage: 20269, name: 'x-cp20269', displayName: 'ISO-6937'},
      {codePage: 51932, name: 'euc-jp', displayName: 'Japonês (EUC)'},
      {codePage: 20932, name: 'EUC-JP', displayName: 'Japonês (JIS 0208-1990 e 0212-1990)'},
      {codePage: 50220, name: 'iso-2022-jp', displayName: 'Japonês (JIS)'},
      {codePage: 50222, name: 'iso-2022-jp', displayName: 'Japonês (JIS-Permitir Kana de 1 byte - SO/SI)'},
      {codePage: 50221, name: 'csISO2022JP', displayName: 'Japonês (JIS-Permitir Kana de 1 byte)'},
      {codePage: 10001, name: 'x-mac-japanese', displayName: 'Japonês (Mac)'},
      {codePage: 932, name: 'shift_jis', displayName: 'Japonês (Shift-JIS)'},
      {codePage: 28593, name: 'iso-8859-3', displayName: 'Latino 3 (ISO)'},
      {codePage: 28605, name: 'iso-8859-15', displayName: 'Latino 9 (ISO)'},
      {codePage: 865, name: 'IBM865', displayName: 'Nórdico (DOS)'},
      {codePage: 20108, name: 'x-IA5-Norwegian', displayName: 'Norueguês (IA5)'},
      {codePage: 855, name: 'IBM855', displayName: 'OEM Cirílico'},
      {codePage: 437, name: 'IBM437', displayName: 'OEM Estados Unidos'},
      {codePage: 858, name: 'IBM00858', displayName: 'OEM Latino Multilíngüe I'},
      {codePage: 860, name: 'IBM860', displayName: 'Português (DOS)'},
      {codePage: 10010, name: 'x-mac-romanian', displayName: 'Romeno (Mac)'},
      {codePage: 20107, name: 'x-IA5-Swedish', displayName: 'Sueco (IA5)'},
      {codePage: 20261, name: 'x-cp20261', displayName: 'T.61'},
      {codePage: 10021, name: 'x-mac-thai', displayName: 'Tai (Mac)'},
      {codePage: 874, name: 'windows-874', displayName: 'Tai (Windows)'},
      {codePage: 20001, name: 'x-cp20001', displayName: 'TCA Taiwan'},
      {codePage: 20004, name: 'x-cp20004', displayName: 'TeleText Taiwan'},
      {codePage: 857, name: 'ibm857', displayName: 'Turco (DOS)'},
      {codePage: 28599, name: 'iso-8859-9', displayName: 'Turco (ISO)'},
      {codePage: 10081, name: 'x-mac-turkish', displayName: 'Turco (Mac)'},
      {codePage: 1254, name: 'windows-1254', displayName: 'Turco (Windows)'},
      {codePage: 10017, name: 'x-mac-ukrainian', displayName: 'Ucraniano (Mac)'},
      {codePage: 1200, name: 'utf-16', displayName: 'Unicode'},
      {codePage: 1201, name: 'utf-16BE', displayName: 'Unicode (Big-Endian)'},
      {codePage: 12001, name: 'utf-32BE', displayName: 'Unicode (UTF-32 Big-Endian)'},
      {codePage: 12000, name: 'utf-32', displayName: 'Unicode (UTF-32)'},
      {codePage: 65000, name: 'utf-7', displayName: 'Unicode (UTF-7)'},
      {codePage: 65001, name: 'utf-8', displayName: 'Unicode (UTF-8)'},
      {codePage: 20127, name: 'us-ascii', displayName: 'US-ASCII'},
      {codePage: 1258, name: 'windows-1258', displayName: 'Vietnamita (Windows)'},
      {codePage: 20005, name: 'x-cp20005', displayName: 'Wang Taiwan'}];
  }
}
